const FamousBabyModelList = () => import(/* webpackChunkName 'FamousBabyModelList' */ '@/components/Astrology/FamousBaby/FamousBabyModel/FamousBabyModelList/FamousBabyModelList.vue');
const FamousBabyResultList = () => import(/* webpackChunkName 'FamousBabyResultList' */ '@/components/Astrology/FamousBaby/FamousBabyResult/FamousBabyResultList/FamousBabyResultList.vue');

export default {
    path: 'famous-baby',
    name: 'Famous Baby',
    redirect: 'famous-baby-result/',
    meta: {
        label: 'Famous Baby'
    },
    component: {
        name: 'FamousBaby',
        render(c: any) {
            return c('router-view');
        }
    },
    children: [
        {
            path: 'famous-baby-model',
            name: 'famous_baby_model',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Model'
            },
            component: FamousBabyModelList
        },
        {
            path: 'famous-baby-result',
            name: 'famous_baby_result',
            meta: {
                // accessLevel: USER_LIST,
                label: 'Result'
            },
            component: FamousBabyResultList
        }
    ]
};